import styled from '@emotion/styled'
import { Box, Button } from '@mui/material'

export const AdvanceSearchWrapper = styled(Box)(`
    width: auto;
    display: flex;
    justify-content: end;
    align-items: flex-start;
    min-width: 190px;

    & label{
        font-size: 14px;
        font-weight: 400; // 300;
    }

    & .advance-search-btn .dynamicTourText {
      svg {
        width : 50% !important;
      }

      span {
        width : 80%;
        margin-top: 15px;
      }
    }
`)

export const DisplayChipsWrapper = styled(Box)(`
    display: flex;
    align-items: center;
    gap: 4px; 
    flex-wrap: wrap;
    max-width: calc(100% - 140px); 
    
`)

export const ChipsItem = styled(Box)(`
    font-size: 12px;
    font-weight: 400; // 300;
    color: #454545;
    background-color: #F2F8FF;
    padding: 2px 8px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    & span{
        margin-left: 8px;
        cursor: pointer;
        color: #095BBD;
    }
`)

// --------------------------------------

export const FormWrapper = styled(Box)(`
    width: 860px;
`)

export const AdvSearchInputWrapper = styled(Box)(`
    display: flex;
    justify-content: space-between;
    & .themeV2{
        /* width:100%; */
    }
`)

export const LabelNames = styled('span')(`
    color: #454545;
    font-size: 13px;
    font-weight: 600;
`)

export const EmptyRowText = styled('span')(`
    color: #454545;
    font-size: 12px;
    font-weight: 400;
`)

export const AdvSearchInput = styled(Box)(`
    width: 65%;
    display: flex;
    align-items: center;
    & form{
        width: 100%;
    }
    .MuiBox-root{
        width: 100%;
    }
`)
export const AdvSearchCheckbox = styled(Box)(`
    width: 37%;
    display: flex;
    align-items: center;
    justify-content: center;

    & label{
        display: flex;
        align-items: center;
    }

    &.adv-search-r {
      gap : 9px;
    }
`)

export const CenterAddRowWrapper = styled(Box)(`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
`)
export const AddRowBoxWrapper = styled(Box)(`
    max-height: calc(100vh - 440px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
`)

export const RadioWrapper = styled(Box)(`
    padding: 12px;
    background-color: #E4EEFB;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`)
export const TopContent = styled(Box)(`
    display: flex;
    gap: 10px;
    justify-content : space-between;
`)
export const LeftRadio = styled(Box)(`
    display: flex;
    align-items: center;
    gap: 5px;
`)
export const RightCheckBox = styled(Box)(`
    display: flex;
    align-items: center;   
    gap: 9px; 
    width: 42%;
`)

export const BottomInput = styled(Box)(`
    display: flex;
    align-items: baseline;
    gap: 10px;
     & .searchBox{
        width: 545px;
    }

    & .themeV2.form-check-label-p {
      gap : 8px;
    }

    & .themeV2 {
      .with-error {
        height : auto;

        .Mui-error {
          margin-left : 0;
        }
      }
    }
`)

export const TrashButton = styled(Box)(
  ({ disabled }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    cursor: pointer;
    color: ${disabled ? '#ADADAC' : 'red'};
  
    &:hover {
      color: ${disabled ? '#ADADAC' : '#000'};
    }
  
    &:active {
      color: #686867;
    }
`
)

export const AddNewRowWrapperBtn = styled(Box)(` `)

export const AdvanceFilterWrapper = styled(Box)(` `)

export const FiltersBox = styled(Box)(`
    dislpay: flex;
    gap: 8px;
    & .filterItemWrap{
        width: 100%;
    }
    & form{
        display: flex;
        justify-content: space-between;
    }

`)

export const AdvacneReplyBox = styled(Box)(`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #FFE8CC;
    width: calc(100% + 56px);
    margin-left: -28px;
    padding: 8px 28px;
    display: flex;
    align-items: center;
`)
export const TextIconWrapper = styled(Box)(`
    display: flex;
`)
export const TextWrapper = styled(Box)(`
    font-size: 13px;
    font-weight: 400; 
    color: #D47501; 
`)
export const Highlight = styled('span')(`
    font-weight: 700;
    color: #D47501; 
`)
export const AdvanceButtonsWrapper = styled(Box)(`
    display: flex;
    justify-content: space-between;
`)
